import { CircularProgress, styled } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { ReactComponent as RoleIcon } from "../../../../svg/adminRoleIcon.svg";
import { ReactComponent as Arrow } from "../../../../svg/arrow.svg";
import { ReactComponent as DeleteIcon } from "../../../../svg/deleteIcon.svg";
import apiCall from "../../../../utils/apiCall";
import SettingsModal from "../SettingsModal/settingsModal";
import EditCertificateIndustry from "./EditIndustrySetUp";
// import DeleteIndustryContent from "./deleteIndustryContent";
import ViewIndustryContent from "./ViewIndustryContent";
import { ReactComponent as World } from '../../../../svg/world.svg';
import CreateIndustryContent from "./CreateIndustrySetUpContent";
import DeleteIndustrySetUp from "./DeleteIndustrySetUp";
import { AxiosError } from "axios";
import EditIndustryContent from "./EditIndustrySetUp";

interface ButtonProp {
  handleClick?: () => void;
}
interface AllIndustryData {
  IsActive: boolean;
  IndustryId: number;
  IndustrySector: string;
  IndustryName:string;
}

const IndustryEditIndustrySetUp: React.FC<ButtonProp> = ({ handleClick }) => {
    const [Name, setName] = useState('');
    const [id, setId] = useState(0);
    const [IndustrySector ,setIndustrySector] = useState('')
    const [IsActive,setIsActive] = useState<boolean>(false);
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openRoleModal, setOpenRoleModal] = useState(false);
    const [openCard, setOpenCard] = useState(false);
  
    const handleOpenCreateModal = () => setOpenCreateModal(true);
    const handleCloseCreateModal = () => setOpenCreateModal(false);
  
    const handleOpenEditModal = () => setOpenEditModal(true);
    const handleCloseEditModal = () => setOpenEditModal(false);
  
    const handleOpenDeleteModal = () => setOpenDeleteModal(true);
    const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  
    const handleOpenRoleModal = () => setOpenRoleModal(true);
    const handleCloseRoleModal = () => setOpenRoleModal(false);
  
    const handleCard = () => setOpenCard(!openCard);
  
    const handleRole = () => {
      setOpenCard(false);
      handleCloseRoleModal();
    };
  
    const handleDisable = () => {
      handleCloseRoleModal();
      setOpenCard(false);
      handleOpenDeleteModal();
    };
  
    const handleEdit = () => {
      handleCloseRoleModal();
      setOpenCard(false);
      handleOpenEditModal();
    };

    const handleOpen = (setupIndustry: AllIndustryData) => {
      setId(setupIndustry?.IndustryId)
      setName(setupIndustry?.IndustryName)
      setIndustrySector(setupIndustry?.IndustrySector)
      setIsActive(setupIndustry?.IsActive?true:false);
      handleOpenRoleModal();
    }
    
  const GetAllIndustry = async (): Promise<any> => {
    return await apiCall().get(`/SetUp/GetAllIndustry`);
  };

  const { data, isLoading, isError, error } = useQuery(
    ["get-AllIndustry"],
    GetAllIndustry,
    {
      keepPreviousData: true,
      retry: 0,
      enabled: true,
      onSuccess(data) {

      },
      onError(err){

      }
    }
  );

  const IndustryEditIndustrySetUpError = error as AxiosError;
  const IndustryEditIndustrySetUpErrorMessage = IndustryEditIndustrySetUpError?.message;

  return (
    <>
    {isLoading ? (
      <CircularProgress 
        sx={{
          fontSize: '1rem',
          marginInline: 'auto',
          display: 'block',
          marginBlock: '2rem'
        }}
      />
    ) : isError ? (
      <StyledError>{IndustryEditIndustrySetUpErrorMessage}</StyledError>
    ) : (
      <StyledContainer>
        <TotalWrapper>
          <span>Total</span>
          <TotalNumberStyle>{data?.data?.Data.length}</TotalNumberStyle>
        </TotalWrapper>
        {data?.data?.Data &&
        data?.data?.Data.length > 0 &&
        data?.data?.Data.map((data: AllIndustryData) => (
          <RoleWrapper onClick={() =>{
            handleOpen(data)
          } } key={data.IndustryId}>
            <div>
              <RoleIconWrapper>
                <RoleIcon />
              </RoleIconWrapper>
              <RoleText>{data.IndustryName}</RoleText>
              <Active disabled={data.IsActive}>{data.IsActive?'Active':'Disabled'}</Active>
              <DateWrapper>{data.IndustrySector}</DateWrapper>
            </div>
          
            <ArrowIconWrapper>
              <Arrow />
            </ArrowIconWrapper>
          </RoleWrapper>
        ))}

        <SettingsModal
          header={Name}
          open={openRoleModal}
          maxWidth={"712px"}
          content={<ViewIndustryContent IndustryName={Name} IsActive={IsActive} IndustrySector={IndustrySector} IndustryId={id}/>}
          cancel={setOpenRoleModal}
          showrightIcon={true}
          worldIcon={<World/>}
          card={
            <>
              <CardItems onClick={handleEdit}>Update</CardItems>
              {/* <CardItems onClick={handleDisable}>Delete</CardItems> */}
            </>
          }
        />
        <SettingsModal
          header="Update Industry"
          open={openEditModal}
          maxWidth={"480px"}
          content={<EditIndustryContent handleClose={handleCloseEditModal} IndustryName={Name} IndustryId={id} IndustrySector={IndustrySector} IsActive={IsActive} />}
          cancel={setOpenEditModal}
          showrightIcon={false}
          worldIcon={<World/>}
        />
   
        <SettingsModal
          header="Delete Industry"
          open={openDeleteModal}
          maxWidth={"536px"}
          content={<DeleteIndustrySetUp 
            IndustrySector={IndustrySector} 
            IndustryName={Name} 
            IsActive={IsActive}
            IndustryId={id} 
            handleClose={handleCloseDeleteModal} 
          />}
          cancel={setOpenDeleteModal}
          showrightIcon={false}
          worldIcon={<DeleteIcon/>}
        />
      </StyledContainer>
    )}
    
    </>
  );
};

export default IndustryEditIndustrySetUp;

const StyledContainer = styled("div")`
  margin-block: 3.8rem;
  margin-inline: 3.5rem;
`;

const TotalNumberStyle = styled("span")`
  background-color: #f1f3f4;
  border-radius: 0.2rem;
  margin-inline-start: 0.4rem;
  padding-inline: 0.2rem;
`;

const TotalWrapper = styled("div")`
  color: #4e5a62;
  font-weight: 500;
`;

const RoleWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  border: 0.1rem solid #e1e1e1;
  margin-block: 0.6rem;
  padding-inline: 1.2rem;
  padding-block: 1.2rem;
  border-radius: 0.5rem;
  width: 100%;
  text-align: left;
  background-color: transparent;
`;

const RoleIconWrapper = styled("span")`
  background-color: #fff4de;
  border-radius: 0.1rem;
  padding-inline: 0.4rem;
`;

const RoleText = styled("span")`
  font-weight: 600;
  font-size: 16px;
  margin-inline: 0.8rem;
`;
const SampleSpan = (props:any)=>{
  const children = props.children;
  return (<span {...props}>{children}</span>)
}
export const Active = styled(SampleSpan)`
  font-size: 14px;
  font-weight: 500;
  background-color: #e0faee;
  border-radius: 0.4rem;
  padding-inline: 0.5rem;
  color: ${props => props.diabled?'pink':'#11643c'};
`;

const DateWrapper = styled("div")`
  margin-block-start: 0.8rem;
  font-size: 14px;
`;

const ArrowIconWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const CardItems = styled(`div`)`
  height: 41px;
  background: #FFFFFF;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-inline-start: 23px;

  &:hover {
    background: #F1F1F1;
  }

`

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`